





























































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";
import { AppConstants } from "../core/Export";
import $ from "jquery";
import { date } from "quasar";

@Component({ components: {} })
export default class AppForm1312 extends Vue {
  @Prop() addChildLine: Function;
  @Prop() onOpenSignDialog: Function;
  @Prop() onSendRequestForm: Function;
  @Prop({ default: true }) canSaveAndExit: boolean;
  @Prop() signatureImgSrc: any;
  @Prop() isSignaturePadEmpty: boolean;
  @Prop() isInViewMode: boolean;
  dateMask: string = "DD/MM/YYYY";
  martialStatusOptions: Array<any>;
  medicalClinicOptions: Array<any>;
  constructor() {
    super();
    this.martialStatusOptions = this.systemData["baseItems"].filter(
      (s) => s.parentCode == AppConstants.BaseItemsParentCodes.FamilyStatus
    );
    this.medicalClinicOptions = this.systemData["baseItems"].filter(
      (s) => s.parentCode == AppConstants.BaseItemsParentCodes.KupatHolim
    );
  }

  openSignWin() {
    $(".openSignWin").click();
  }

  showFileSelect(e) {
    if (e) {
      e.preventDefault();
    }
    let fileElm = document.getElementById("file_input");
    if (fileElm) {
      fileElm.click();
    }
  }

  getFileName() {
    let fileElm = document.getElementById("file_input");
    if (fileElm) {
      let file = fileElm["files"][0];
      if (file) {
        return file.name;
      } else {
        return "לא נבחר קובץ";
      }
    } else {
      return "לא נבחר קובץ";
    }
  }

  onPhoneNoPressed(e) {
    let regex = /\D/g;
    if (regex.test(e.key)) {
      e.preventDefault();
    }
  }

  getEmailValidationMsg(value) {
    if (!value) {
      return "שדה חובה";
    } else {
      return "אימייל לא חוקי";
    }
  }

  onBlurNoOfChildsUpTo18(e) {
    if (!this.tRequestFormData.noOfChildsUpTo18) {
      this.tRequestFormData.noOfChildsUpTo18 = 0;
    }
  }

  onIsPensionerChanged(e) {
    let requestForm = this.$refs.requestForm as any;
    requestForm.resetValidation();
  }

  onHmoChanged(e) {
    if (e === "Zahal") {
      this.tRequestFormData.hmoBranch = "";
      let requestForm = this.$refs.requestForm as any;
      requestForm.resetValidation();
    }
  }

  validateHmoBranch(value) {
    if (this.tRequestFormData.hmo == "Zahal") return true;
    if (!value) return false || "שדה חובה";
    return true;
  }

  validatePartnerOrChildDob(value) {
    if (value && value != "__/__/____") {
      return (
        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(value) ||
        "תאריך לא חוקי"
      );
    }
    return true;
  }

  validateResidentDob(value) {
    if (!value || value == "__/__/____") {
      return false || "שדה חובה";
    } else if (this.is1312DataIsEditable) {
      return (
        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(value) ||
        "תאריך לא חוקי"
      );
    } else {
      return true;
    }
  }

  validateResidentFromDate(value) {
    if (!value || value == "__/__/____") {
      return false || "שדה חובה";
    } else if (this.is1312DataIsEditable) {
      let isDateValid = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(
        value
      );
      if (!isDateValid) {
        return false || "תאריך לא חוקי";
      } else if (this.tRequestFormData.dob && this.tRequestFormData.dob != "__/__/____") {
        let dob = this.extractDate(this.tRequestFormData.dob);
        let residentFromDate = this.extractDate(value);
        return !(residentFromDate < dob) || "תאריך תושבות קטן מתאריך לידה";
      }
    } else {
      return true;
    }
  }

  extractDate(value) {
    if (value) return date.extractDate(value, "DD/MM/YYYY");
  }

  validateWorkPlaceNameOrAddress(value) {
    if (this.tRequestModel.requestDto.isPensioner) {
      return true;
    } else {
      return value && value.length > 0;
    }
  }

  validateNoOfChildsUpTo18(value) {
    if (value < 0) {
      return false;
    } else {
      return true;
    }
  }

  validateEmail(value) {
    if (!value) {
      return false;
    } else if (value) {
      let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(value.toLowerCase());
    } else {
      return true;
    }
  }

  validateWorkPlacePhoneNo(value) {
    if (this.tRequestModel.requestDto.isPensioner) {
      return true;
    } else {
      return this.validatePhoneNo(value);
    }
  }

  validatePhoneNo(value) {
    let numRegex = /\D/g;
    if (!value) {
      return false;
    } else if (value.length < 9) {
      return false;
    } else if (numRegex.test(value)) {
      return false;
    } else {
      return true;
    }
  }

  validatePartnerPhoneNo(value) {
    let numRegex = /\D/g;
    if (value) {
      if (value.length < 9) {
        return false;
      } else if (numRegex.test(value)) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  getPhoneNoValidationMsg(value) {
    let numRegex = /\D/g;
    if (!value) {
      return "שדה חובה";
    } else if (numRegex.test(value)) {
      return "מס' טלפון יכול להכיל ספרות בלבד";
    } else {
      return "מס' טלפון מינימום 9 ספרות";
    }
  }

  topFunction() {
    $("html,body").animate({ scrollTop: 0 }, 400);
  }

  bottomFunction() {
    $("html,body").animate({ scrollTop: document.body.scrollHeight }, 400);
  }

  get logoImg() {
    if (this.systemData && this.systemData["systemSettings"]) {
      var url: string = AppConstants.Http.BaseUrl;
      url = url.replace("/api", "");
      return `${url}/logos/${this.systemData["systemSettings"].authorityCode}.png`;
    } else {
      return;
    }
  }

  get showUploadedIdHint() {
    if (this.tRequestModel.filesList && this.tRequestModel.filesList.length > 0) {
      let idFile = this.tRequestModel.filesList.find(
        (s) => s.code == AppConstants.FileToUploadCodes.Id
      );
      if (idFile) {
        return "(קובץ הועלה, אין חובה להעלות בשנית)";
      }
    } else {
      return null;
    }
  }

  get is1312DataIsEditable() {
    return this.systemData.systemSettings.is1312DataIsEditable;
  }

  get systemData() {
    return store.getters.systemData;
  }

  get isWorkPlaceIsNotMandatory() {
    return this.systemData.systemSettings.isWorkPlaceIsNotMandatory;
  }

  get tRequestModel() {
    return store.getters.tRequestModel;
  }

  get tRequestFormData() {
    if (this.isInViewMode) {
      return this.tRequestModel;
    } else {
      return this.tRequestModel.requestDto.requestFormObj;
    }
  }
}
